"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getFlagUrl;
function getFlagUrl(countryCode) {
  return "https://jl-money-static-assets-prod.storage.googleapis.com/Flags/".concat(countryCode.toLowerCase(), ".svg");
}